/**
 * Main app
 * 
 */

'use strict';

// Example component import
// import { Hello } from './hello.js';

class App
{
  constructor()
  {
    this.scroll_animation();
    this.calc_sticky_height();
    this.agenda_accordion();
    this.speakers();
  }

  /**
   * Scroll animation
   * 
   */
  scroll_animation()
  {
    const observer = new IntersectionObserver( ( entries ) => {
      entries.forEach( ( e ) => {
        if ( e.target.classList.contains('viewport-animate') && e.intersectionRatio > 0 )
        {
          e.target.classList.add( e.target.dataset.animation );
        }
      });
    }, { threshold: 0.2 } );

    const anim_el = document.querySelectorAll('.viewport-animate');

    anim_el.forEach( ( animationItem ) => {
      observer.observe( animationItem );
    } );
  }

  calc_sticky_height()
  {
    const stickyMenu = document.querySelector('header.menu');
    const root       = document.documentElement;

    function calcStickyHeight()
    {
      var stickyHeight = stickyMenu.offsetHeight;
      
      root.style.setProperty('--sticky-height', stickyHeight + 'px');
    }

    window.addEventListener( 'load', calcStickyHeight );
    window.addEventListener( 'resize', calcStickyHeight );
  }

  /**
   * Agenda accordion
   * 
   */
  agenda_accordion()
  {
    // Check for URL hash and open accordion as needed
    window.addEventListener('load', () => {
      const hash = window.location.hash;

      if ( hash )
      {
        const agenda = document.getElementById(hash.substring(1));

        if ( agenda )
        {
          const bottom = agenda.querySelector('.agenda-section-group-item-content-bottom');

          if ( bottom )
          {
            bottom.classList.add('active');
            agenda.querySelector('a.expand').classList.add('active');
          }
        }
      }
    });

    // Expand individual
    document.querySelectorAll('.agenda-section-group-item').forEach( section => {
      let expand    = section.querySelector('a.expand'),
          accordion = section.querySelector('.agenda-section-group-item-content-bottom');

      if ( expand )
      {
        expand.addEventListener('click', function( e )
        {
          e.preventDefault();

          accordion.classList.toggle('active');

          this.classList.toggle('active');

          if ( this.classList.contains('active') )
            window.location.hash = section.id;
          else
            history.replaceState(null, null, ' ');
        });
      }
    });

    // Expand all
    let expand = document.querySelector('.agenda-section-group-options .expand-all');

    if ( expand )
    {
      expand.addEventListener('click', function( e )
      {
        e.preventDefault();

        this.classList.toggle('active');

        if ( this.classList.contains('active') )
        {
          document.querySelectorAll('.agenda-section-group-item-content-bottom').forEach( item => item.classList.add('active') );
          document.querySelectorAll('.agenda-section-group-item a.expand').forEach( item => item.classList.add('active') );
        }
        else
        {
          document.querySelectorAll('.agenda-section-group-item-content-bottom').forEach( item => item.classList.remove('active') );
          document.querySelectorAll('.agenda-section-group-item a.expand').forEach( item => item.classList.remove('active') );
        }
      });
    }
  }

  /**
   * Speakers
   * 
   */
  speakers()
  {
    document.querySelectorAll('.speakers .item').forEach( item => {
      let more = item.querySelector('a.show-bio');

      if ( more )
      {
        more.addEventListener('click', ( e ) => {
          e.preventDefault();

          document.querySelectorAll('.speakers .bio').forEach( bio => bio.classList.remove('active') );

          document.querySelectorAll('.speakers .item:not(#' + item.id + ')').forEach( item => item.classList.remove('active') );

          // Hide
          if ( item.classList.contains('active') )
          {
            item.classList.remove('active');
            item.nextElementSibling.classList.remove('active');

            document.querySelector('.speakers').classList.remove('active');
          }

          // Show
          else
          {
            item.classList.add('active');
            item.nextElementSibling.classList.add('active');

            document.querySelector('.speakers').classList.add('active');

            item.scrollIntoView();
          }
        });
      }
    });

    // Mobile - X close bio
    document.querySelectorAll('.speakers .bio a.close-bio').forEach( close => {
      close.addEventListener('click', ( e ) => {
        e.preventDefault();

        document.querySelector('.speakers').classList.remove('active');
        document.querySelectorAll('.speakers .item').forEach( item => item.classList.remove('active') );
        document.querySelectorAll('.speakers .bio').forEach( bio => bio.classList.remove('active') );
      });
    });
  }

  init()
  {
    //
  }
}

const app = new App;

app.init();